'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'door-closed';
var width = 576;
var height = 512;
var aliases = [128682];
var unicode = 'f52a';
var svgPathData = ['M96 64l0 384 0 64 384 0 0-64 0-384c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64zM416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M384 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 480c0-17.7 14.3-32 32-32l64 0 0 64-64 0c-17.7 0-32-14.3-32-32zm576 0c0 17.7-14.3 32-32 32l-64 0 0-64 64 0c17.7 0 32 14.3 32 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorClosed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;